import { graphql } from "@opensea/graphql"

export const CollectionSweepStatus_quoteFragment = graphql(`
  fragment CollectionSweepStatus_quote on CollectionSweepQuoteResponse {
    collection {
      imageUrl
    }
    quote {
      __typename
      ... on CollectionSweepQuoteSuccess {
        itemQuotes {
          item {
            id
            imageUrl
          }
        }
      }
    }
  }
`)
